<template>
    <div class="investors-s">
        <p class="indent">Капиталът на дружеството е разпределен в 17 952 959 броя акции с номинална стойност по 1 (един) лев всяка.</p>
        <p class="indent">Акциите са регистрирани на неофициалния фондов пазар под емисия BG11ALSUAT14 като неделими, безналични, поименни, с право на глас, дивидент и ликвидационен дял, съизмерим на номиналната стойност на акцията. Борсов код на неофициалния фондов пазар – 6AM /ALUM/.</p>
        <img class="investors-chart" src="/static/img/investors/shares/chart.svg" alt="Chart">
        <p class="indent">Правата по акциите, емитирани от дружеството, се установяват с документ за регистрация, издаден от Централен депозитар АД, като документът за регистрация е непрехвърляем. Прехвърлянето на акции може да се извършва свободно между акционерите и трети лица при спазване разпоредбите на българското законодателство. Не се допуска издаването на привилегировани акции, даващи право на повече от един глас или допълнителен ликвидационен дял.</p>
        <p class="indent">Книгата за акционерите на дружеството се води от Централен депозитар АД – София по предвидения в закона ред.</p>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.investors-s {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.investors-s > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.investors-s > p:last-of-type {
  margin-bottom: 0;
}
.investors-chart {
  margin: 20px 0 0;
  width: 60%;
}
@media screen and (max-width: 1000px) {
  .investors-s > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .investors-chart {
    width: calc(100% - 30px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/Shares.vue